var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto hide-scrollbars bg-light"},[_c('div',{staticClass:"border-bottom border-light p-2 d-flex"},_vm._l((_vm.subMenuItems),function(item){return _c('b-btn',{key:item.label,staticClass:"px-4 mr-2 btn-brand",class:{
                'border-primary border-heavy': _vm.isCurrentSubpage(item.path),
            },attrs:{"variant":"light","pill":""},on:{"click":function($event){return _vm.setPath(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }